import { useCategoryThreadsQuery } from 'graphql/generated'
import { useCallback } from 'react'

const LIMIT = 20
function useCategoryThreads(categoryId: string) {
  const { data, loading, fetchMore, networkStatus, refetch } =
    useCategoryThreadsQuery({
      notifyOnNetworkStatusChange: true,
      variables: {
        categoryId,
        threadConnection: {
          first: LIMIT
        },
        collaboratorConnection: {
          first: 5
        }
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first'
    })

  const loadingMore = networkStatus === 3
  const threads =
    data?.category.threads.edges
      .map(edge => edge.node)
      .filter(thread => !thread.deletedAt) || []

  const loadMore = useCallback(() => {
    if (
      !data?.category.threads.pageInfo ||
      !data?.category.threads.pageInfo?.hasNextPage
    ) {
      return
    } else if (loading || loadingMore) {
      return
    }

    fetchMore({
      variables: {
        categoryId,
        threadConnection: {
          first: LIMIT,
          after: data.category.threads.pageInfo.endCursor
        },
        collaboratorConnection: {
          first: 5
        }
      }
    })
  }, [
    categoryId,
    data?.category.threads.pageInfo,
    fetchMore,
    loading,
    loadingMore
  ])

  return { threads, loadMore, loading: loading, loadingMore, refetch }
}
export default useCategoryThreads
